module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAYAAACoPemuAAAAAXNSR0IArs4c6QAAAKVJREFUWEft11EOQEAMBNCZe3AgF3EoF3Eg7jF+SDZrf6qExPgUrebp7hZx0yVpADDt6UaScyY1M8FlrKQFQLffW0n2mdx3FqayEJKp3KngSsyFhVpEksUs1hLwqgz1BQCLWawW8AYb7Yn/iBWT5zHkRbEeeZ7V5PnIS64k/XRhx0/Etz7lFeZWzH9WpcWCAh57gmAeFKNgFrPYScBHUrQpLPa22AZMkpoX0f9DqQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/images/add.png
// module id = HlCa
// module chunks = 1